import NavBarAdmin from "../../components/Admin/Layout/NavBarAdmin";
import PartnerAdminTable from "../../components/Admin/Table/PartnerAdminTable";
import { useEffect } from "react";
import useModal from "../../hooks/useModal";
import CreateUser from "../../components/Admin/Modales/CreateUser";
import SearchBar from "../../components/Admin/Services/SearchBar";
import { usePartnerStore } from "../../stores/admin/users";
import { useServiceStore } from "../../stores/admin/service";
import { useParams } from "react-router-dom";
import { getAllPartners } from "../../services/Api/adminService";
import { ToastContainer } from "react-toastify";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import { showToastError } from "../../services/Toasts/toasts";

const AdminPartner = () => {
  // Store
  const { usersPartner, setUsersPartner } = usePartnerStore();
  const { update, searchTerm } = useServiceStore();
  const { idPartner } = useParams();
  
  // Hook
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();

  // Function to display users partner filtered or not
  useEffect(() => {
    if (searchTerm !== "") {
      const filteredRequests = usersPartner.filter(
        (item: any) =>
          item?.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.eMail.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setUsersPartner(filteredRequests);
    } else {
      getAllPartners(Number(idPartner))
        .then((data) => setUsersPartner(data))
        .catch(() => showToastError("Une erreur s'est produite"));
      }
  }, [searchTerm, update]);

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      {isModalOpen ? modalContent : null}
      <Header />
      <div className="w-full flex justify-start items-start">
        <ToastContainer position="top-center" />
        <NavBarAdmin />
        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          {/* Header Section */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 my-3 border border-gray-100">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-yellow-trio rounded-xl">
                  <svg className="w-6 h-6 text-grey-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-700 font-K2D">
                    Liste des collaborateurs <span className="text-yellow-trio">({usersPartner.length})</span>
                  </h1>
                  <p className="text-gray-600 text-md mt-1">
                    Gérez les utilisateurs partenaires et leurs accès
                  </p>
                </div>
              </div>
              
              <button
                className="px-6 py-3 bg-yellow-trio text-gray-700 cursor-pointer font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2"
                onClick={() => openModal(<CreateUser closeModal={closeModal} />)}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Créer un utilisateur
              </button>
            </div>
          </div>

          {/* Barre de recherche  */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 mb-3 border border-gray-100">
              <div className="w-80">
                <SearchBar />
              </div>
          </div>

          {/* Table des collaborateurs */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            <PartnerAdminTable />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminPartner;
